import { Text } from '@wework/dieter-ui'
import Row from '../Common/Row'
import React, { useEffect, useState, FunctionComponent } from 'react'
import './styles.css'
import { RightArrow } from '../Icons'
import IMTheme from '../../style/IMTheme'
import LinkedRoom from './LinkedRoom'

interface InternalRoomsProps {
  floorMap: any
  space: any
  setSelectedInternalsRooms: (any) => void
  handleInternalRoomClick: (any) => void
  getFloorName: (string) => string
  isColapsable: boolean
}

const InternalRooms: FunctionComponent<InternalRoomsProps> = ({
  floorMap,
  space,
  setSelectedInternalsRooms,
  getFloorName,
  handleInternalRoomClick,
  isColapsable = false,
}) => {
  const [collapsed, setCollapsed] = useState(false)
  const [loading, setLoading] = useState(true)
  const [internals, setInternals] = useState<any>([])

  useEffect(() => {
    if (!floorMap) {
      return
    }
    const inventoryExt = floorMap.getExtension('inventoryData')

    async function fetchHistory() {
      const data = await inventoryExt.getInternals(space.uuid)
      setInternals(data || [])
      setSelectedInternalsRooms(data || [])
      setLoading(false)
    }
    if (inventoryExt && space) {
      setLoading(true)
      fetchHistory()
    }

    return () => {
      setInternals([])
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [floorMap, space])

  return (
    <div style={{ marginTop: 0 }}>
      {loading ? (
        <Row style={{ marginBottom: 8 }}>
          <Text
            style={{
              fontWeight: IMTheme.fontWeights.bold,
              fontSize: IMTheme.fontSizes[2],
            }}
          >
            Loading internal Rooms ...
          </Text>
        </Row>
      ) : (
        internals.length > 0 && (
          <>
            <Row style={{ marginBottom: 8 }}>
              <Text
                style={{
                  fontWeight: IMTheme.fontWeights.bold,
                  fontSize: IMTheme.fontSizes[2],
                }}
              >
                Internal room
              </Text>
              {isColapsable && (
                <div
                  onClick={() => setCollapsed(!collapsed)}
                  style={{
                    cursor: 'pointer',
                    transform: collapsed ? 'rotate(-90deg)' : 'rotate(90deg)',
                    width: 12,
                    height: 12,
                  }}
                >
                  <RightArrow />
                </div>
              )}
            </Row>
            {!collapsed && (
              <div style={{ flexDirection: 'column', display: 'flex' }}>
                {internals.map((internal, index) => {
                  return (
                    <LinkedRoom
                      key={internal?.office_number}
                      roomNumber={internal?.office_number}
                      floor={getFloorName(internal?.floor_uuid)}
                      handleInternalRoomClick={() =>
                        handleInternalRoomClick(internal)
                      }
                    />
                  )
                })}
              </div>
            )}
          </>
        )
      )}
    </div>
  )
}

export default InternalRooms
